import React from 'react';
import ClientDefault from 'shared/components/client-card/ClientDefault';

class ClientAssignList extends React.Component {
  render() {
    const { clientsId, clients } = this.props;

    return (
      <ul className="nutrition-client-list assign-client-list">
        {clients.map(client => {
          return !clientsId.includes(client.id) ? (
            <li key={client.id}>
              <ClientDefault client={client} />
            </li>
          ) : null;
        })}
      </ul>
    );
  }
}

export default ClientAssignList;
